import { createContext, useContext, useEffect, useState } from "react";
import { ApplicationUser } from "../types/user";
import { getUserProfile } from "../services/userService";

interface UserContextProps {
  //organisation?: Organisation;
  currentUser: ApplicationUser | null;
  isLoaded: boolean;
  fetched: boolean;
}

interface UserProviderProps {
  children: React.ReactNode;
}

const UserProviderContext = createContext<UserContextProps | undefined>(undefined);

export const UserProvider : React.FC<UserProviderProps> = ({ children }) => {
    const [currentUser, setCurrentUser] = useState<ApplicationUser | null>(null);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [fetched, setFetched] = useState<boolean>(false);
    
    useEffect(() => {
        const fetchUserProfile = async () => {
      try {
        const userProfile = await getUserProfile();
        setCurrentUser(userProfile);
        setIsLoaded(true);
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
        setFetched(true);
      } finally{
        setIsLoaded(false);
        setFetched(true);
      }
    };

    if(!currentUser) {
        fetchUserProfile();
    }
    }, [currentUser]);
    
    return (
        <UserProviderContext.Provider value={{ currentUser, isLoaded,fetched }}>
        {children}
        </UserProviderContext.Provider>
    );
}

export const useUser = () : UserContextProps => {
    const context = useContext(UserProviderContext);
    if (!context) {
        throw new Error("useUser must be used within a UserProvider");
    }
    return context;
}